import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useBreadcrumb } from "../context/BreadcrumbContext";
import { theme } from "../theme/theme";
import { BASE_URL } from '../constants'


const GlobalBreadcrumbs = () => {
  const { breadcrumbs } = useBreadcrumb();

  if (breadcrumbs.length === 0) return null;

  return (
    <Breadcrumb className=" d-flex align-items-center mt-2">
      {/* <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
        Home
      </Breadcrumb.Item> */}
      {breadcrumbs.map((crumb, idx) => {
        const isLast = idx === breadcrumbs.length - 1;
        if(isLast) {

        
        return (
          <Breadcrumb.Item
            key={crumb.path}
            linkAs={Link}
            style={{backgroundColor:`${theme.colors.secondary}10`, color: theme.colors.primary ,fontSize:theme.font.size.large,  fontWeight:'bold' , padding: '0 8px'}}
            linkProps={!isLast ? { to: crumb.path } : undefined}
            active={isLast}
          >
            {crumb.name.charAt(0).toUpperCase() + crumb.name.slice(1)}
          </Breadcrumb.Item>
        );}
      })}
    </Breadcrumb>
  );
};

export default GlobalBreadcrumbs;
